module.exports = __webpack_public_path__ + "img/img29.8dc0c8b4.svg";